import { Pipe, PipeTransform } from '@angular/core';
import { FormatType } from '../enums/format-type.enum';
import { FormatHelper } from '../helpers/format.helper';

@Pipe({
  name: 'percentage',
  standalone: false,
})
export class PercentagePipe implements PipeTransform {
  transform(value: number): string {
    return FormatHelper.format(value, FormatType.Percentage);
  }
}
